import React         from 'react';
import LoaderButton  from '../../shared/loader-button/loader-button.jsx';
import Alert         from '../../shared/alert';
import LocaleString  from '../../shared/locale-string';
import appHistory    from '../../../history.js';

import './on-the-spot.scss';

class OnTheSpot extends React.Component {
    constructor( props ) {
        super( props );

        this.state = {
            code: ''
        };
    }

    submitCode = () => {
        const { redeem, userName } = this.props;
        const { code } = this.state;

        this.dismissErrorMessages();
        this.dismissSuccessMessages();

        redeem( code, userName );
    };

    handleInputChange = ( event ) => {
        const name = event.target.name;
        this.setState( { [ name ]: event.target.value } );

        this.dismissErrorMessages();
        this.dismissSuccessMessages();
    };

    dismissErrorMessages = () => {
        this.props.errors.forEach( error => this.props.dismissError( error ) );
    };

    dismissSuccessMessages = () => {
        this.props.successMessage.forEach( successMsg => this.props.dismissSuccess( successMsg ) );
    };

    UNSAFE_componentWillMount() {//eslint-disable-line
        this.unlisten = appHistory.listen( ( location, action ) => {
            this.setState( { code: '' } );

            this.dismissErrorMessages();
            this.dismissSuccessMessages();
        } );
    }

    componentWillUnmount() {
        this.dismissErrorMessages();
        this.dismissSuccessMessages();

        if ( this.unlisten ) {
            this.unlisten();
        }
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {//eslint-disable-line
        if ( nextProps.success ) {
            this.setState( { code: '' } );
        }
    }

    render () {
        const { code } = this.state;
        const { tabIndex,
                busy,
                errors,
                dismissError,
                success,
                successMessage,
                dismissSuccess,
                mediaLabel,
                cardPlaceholder,
                disable } = this.props;

        return <div className="on-the-spot" role="form">
            <div className="on-the-spot-description">
                <label htmlFor="onTheSpot">
                    <h3><LocaleString code="ots.content.title" /></h3>
                </label>
                <p><LocaleString code="ots.content.instructions" /></p>
            </div>
            <div className="on-the-spot-input">
                <div className="form-group">
                    <input
                        id="onTheSpot"
                        type="text"
                        name="code"
                        value={ code }
                        tabIndex={ tabIndex }
                        required={ false }
                        onChange={ this.handleInputChange }
                        disabled = { busy }
                        placeholder={ cardPlaceholder }
                    />

                    <LoaderButton
                        busy={ busy }
                        onClick={ this.submitCode }
                        disabled={ !code || success || disable }
                        tabIndex={ tabIndex ? tabIndex + 1 : undefined }
                        done={ success }>
                        <LocaleString code="ots.button.submitLabel" />
                    </LoaderButton>

                </div>

                {
                    errors.length !== 0 && errors.map( ( error, index ) =>
                        <Alert type={ 'error' } onDismiss={ () => dismissError( error ) } key={ index }>
                            <p>
                                <LocaleString code={ error.responseMessage || error.message }
                                    replaceOptions={ { mediaLabel } } />
                            </p>
                        </Alert>
                    )
                }

                {
                    successMessage.length !== 0 &&
                    <Alert type={ 'success' } onDismiss={ () => dismissSuccess( successMessage ) }>
                        <p>
                            <LocaleString code={ successMessage[ 0 ].message.text }
                                replaceOptions={ { mediaLabel, numberOfPoints: successMessage[ 0 ].message.points } } />
                        </p>
                    </Alert>
                }

            </div>
          </div>;
    }
}

OnTheSpot.propTypes = {
};

export default OnTheSpot;
